import {
	Component, Input, SimpleChanges, SimpleChange, HostListener,
	ChangeDetectionStrategy, ChangeDetectorRef, ViewChild
} from '@angular/core';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DeviceDto } from 'UvExplorerServer.Dtos.TS/Session';
import { InfoSetsComponent  } from 'infosets';


@Component({
    selector: 'device-details',
	templateUrl: './devicedetails.component.html',
	styleUrls: ['./devicedetails.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceDetailsComponent {

	@Input()
	public selectedDevice: DeviceDto;
	public get hasSelectedDevice(): boolean {
		return !!this.selectedDevice;
	}

	@Input()
	public isMasterDevice: boolean;
	
	@ViewChild('infosets')
	public infoSets: InfoSetsComponent;

	public display: boolean;
	public deviceDisplayName: string;
	private resizeObserver: ResizeObserver;

	constructor(private changeDetector: ChangeDetectorRef,
		@Inject(DOCUMENT) private document: Document) {

		this.selectedDevice = null;
		this.isMasterDevice = false;
		this.display = false;
		this.deviceDisplayName = "";
		this.resizeObserver = null;
	}
	
	public show(): void {
		this.display = true;

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.display = false;

		this.changeDetector.markForCheck();
	}

	public onShow(): void {
		this.disconnectResizeObserver();
		this.connectResizeObserver();
	}

	public onHide(): void {
		this.disconnectResizeObserver();
		this.hide();
	}

	public onResize(entries: any): void {
		if (this.infoSets) {
			this.infoSets.onResize(entries);
		}
	}

	private connectResizeObserver(): void {
		let dialogDiv = <HTMLDivElement>this.document.querySelector(".device-details-dialog");
		this.resizeObserver = new ResizeObserver((entries) => this.onResize(entries))
		this.resizeObserver.observe(dialogDiv);
	}

	private disconnectResizeObserver(): void {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["selectedDevice"];
		if (change) {
			this.deviceDisplayName = "";
			if (this.selectedDevice) {
				this.deviceDisplayName = this.selectedDevice.displayName;
			}
		}
	}

	public patchData(newDevice: DeviceDto): void {
		this.infoSets.patchData(newDevice);
	}

}
